export let PhoneNumberSources;
(function (PhoneNumberSources) {
  PhoneNumberSources["EXTERNAL_NUMBER"] = "external";
  PhoneNumberSources["HUBSPOT_NUMBER"] = "hubspot";
  PhoneNumberSources["CONNECT_NUMBER"] = "connect";
})(PhoneNumberSources || (PhoneNumberSources = {}));